import { authHeader } from "../../_helpers/auth-header";
import { getDmsToken } from "../../active-directory/getDmsToken";
import { bmAPIs } from "../../api/api-endpoints/BenchmarkingEndpoints";
import isEmpty from "../../validation/is-empty";
import { AutoCloseModal } from "../modal/Modal";

export async function getKeyDocs(data) {
  const { benchmarkId, setError, setModal, file, benchmarkWithRows } = data;

  const formData = new FormData();

  if (isEmpty(file?.name)) {
    return setError({
      text: "Please attach a file",
      type: "feedback-error",
    });
  }

  if (isEmpty(file) && file?.name?.split(".").pop() !== "pdf") {
    setError({
      text: "Please upload a valid PDF file",
      type: "feedback-error",
    });
    return;
  }

  setError({
    text: "Saving...",
    type: "feedback-success",
  });

  const dmsToken = await getDmsToken();
  let dmsBearer = "";
  if (!isEmpty(dmsToken)) {
    dmsBearer = dmsToken.accessToken;
  }

  formData.append("file", file);
  const config = {
    method: "POST",
    body: formData,
    headers: {
      ...authHeader({ authJson: false, authForm: true, guestJson: false }),
      dmsBearer: `Bearer ${dmsBearer}`,
    },
  };
  let url =
    bmAPIs().upload_benchmark_key_document + "?benchmarkId=" + benchmarkId;
  let response = [];
  try {
    response = await fetch(url, config);
  } catch (e) {
    return setError({
      text: "Save Error: " + e.message,
      type: "feedback-error",
    });
  }

  if (response.ok) {
    //Update the key documents list
    benchmarkWithRows.set(await benchmarkWithRows.get(benchmarkId));
    setError({
      text: "Uploaded Successfully",
      type: "feedback-success",
    });
    AutoCloseModal(setModal);
  } else {
    const errorData = await response.json();
    return setError({
      text: errorData.message,
      type: "feedback-error",
    });
  }
}

export async function deleteBenchmarkKeyDoc(
  documentId,
  benchmarkId,
  benchmarkWithRows,
  setIsDeleting
) {
  const url =
    bmAPIs().delete_benchmark_key_document +
    "?benchmarkId=" +
    benchmarkId +
    "&documentId=" +
    documentId;

  const dmsToken = await getDmsToken();
  let dmsBearer = "";
  if (!isEmpty(dmsToken)) {
    dmsBearer = dmsToken.accessToken;
  }

  const config = {
    method: "POST",
    headers: {
      ...authHeader({ authJson: true, authForm: false, guestJson: false }),
      dmsBearer: `Bearer ${dmsBearer}`,
    },
  };

  let response = [];
  try {
    response = await fetch(url, config);
  } catch (e) {
    console.log(e);
  }
  if (response.ok) {
    //Update the key documents list
    benchmarkWithRows.set(await benchmarkWithRows.get(benchmarkId));
    console.log("Deleted Successfully");
    setIsDeleting(false);
  } else {
    console.log("Delete Error");
  }
}
